import React, { useRef, useEffect, useState } from 'react';

import { motion, useInView, useAnimation } from 'framer-motion';
import { 
  FaCloud, 
  FaRobot, 
  FaShieldAlt, 
  FaLaptopCode, 
  FaMobileAlt, 
  FaChartLine,
  FaBuilding,
  FaFlask,
  FaGlobe,
  FaChartBar,
  FaDatabase,
  FaNetworkWired,
  FaCogs,
  FaQuoteLeft,
  FaArrowRight,
  FaCode,
  FaCodeBranch,
  FaConnectdevelop,
  FaBrain
} from 'react-icons/fa';
// import { SiOpenai } from "react-icons/si";
import './body.css';
// import { FaBrain } from "react-icons/fa";
import { MdPsychology } from "react-icons/md";


import { AnimatePresence } from "framer-motion";
import { db } from "../FirebaseComp/firebase"; 
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

import { useNavigate } from "react-router-dom";


// Component for animated numbers
const AnimatedNumber = ({ from = 0, to, duration = 2 }) => {
  const [count, setCount] = useState(from);
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });


    



  useEffect(() => {
    if (isInView) {
      let startTimestamp;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / (duration * 1000), 1);
        const currentCount = Math.floor(progress * (to - from) + from);
        setCount(currentCount);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }, [isInView, to, from, duration]);

  return <span ref={ref}>{count}+</span>;
};





const testimonials = [
  {
    quote: "GLAXMORE provided us with an exceptional booking system that streamlined our tour operations in Ella and Wellawaya. Their technical expertise is remarkable.",
    author: "Dineth Prabhashwara",
    role: "Owner, ChavoTours.lk (Ella-Wellawaya)",
    accent: "var(--primary)"
  },
  {
    quote: "Taxi, Tours and wedding hire booking platform created by GLAXMORE has streamlined our entire operation. Their attention to detail and understanding of our needs was exceptional.",
    author: "Mr. Dishan Pravishka",
    role: "Owner, Rydo.lk (Katunayaka)",
    accent: "var(--primary-light)"
  },
  {
    quote: "GLAXMORE implemented an efficient inventory management system for our cleaning business that has saved us countless hours and reduced errors significantly.",
    author: "Mrs. Keshara",
    role: "Owner, Hero Cleaning Service (Moratuwa)",
    accent: "var(--secondary)"
  },
  {
    quote: "GLAXMORE transformed our eye care operations with a seamless billing, eye exam reporting, and patient follow-up system. It has greatly improved efficiency, accuracy, and patient satisfaction.",
    author: "Mrs. Sarojani Ranathunga",
    role: "Owner, Ranathunga Opticals (Dambulla)",
    accent: "#7c5aee"
  },
  {
    quote: "GLAXMORE introduced an advanced billing, eye exam reporting, and patient follow-up system that has streamlined our daily operations. It's incredibly reliable and has enhanced both efficiency and patient care at our clinic.",
    author: "Mr. Jayamini Edirisinghe",
    role: "Owner, Aklo Vision Center (Dehiwala)",
    accent: "var(--accent)"
  }
];





function Body() {

  // Refs and inView checks for section animations
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const controls = useAnimation();

  const statsRef = useRef(null);
  const statsInView = useInView(statsRef, { once: true, amount: 0.5 });

  const navigate = useNavigate();



  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  // Data
  const services = [
    {
      title: "Cloud Architecture",
      description: "Scalable, secure, and resilient cloud solutions built for future growth.",
      icon: <FaCloud className="service-icon-svg" />
    },
    {
      title: "AI & Machine Learning",
      description: "Intelligent systems that learn from your data and automate complex processes.",
      icon: <FaBrain className="service-icon-svg" />
    },
    {
      title: "Cybersecurity",
      description: "Proactive protection for your digital assets and user data.",
      icon: <FaShieldAlt className="service-icon-svg" />
    },
    {
      title: "Web Development",
      description: "Modern, responsive websites and web applications that drive results.",
      icon: <FaLaptopCode className="service-icon-svg" />
    },
    {
      title: "Mobile Apps",
      description: "Native and cross-platform mobile applications for iOS and Android.",
      icon: <FaMobileAlt className="service-icon-svg" />
    },
    {
      title: "IT Consulting",
      description: "Strategic guidance to optimize your technology infrastructure and processes.",
      icon: <FaChartLine className="service-icon-svg" />
    },
  ];

  const partnerBadges = [
  { name: "TechCorp", icon: <FaBuilding className="client-logo-svg" /> },
  { name: "InnovateLabs", icon: <FaFlask className="client-logo-svg" /> },
  { name: "GlobalSoft", icon: <FaGlobe className="client-logo-svg" /> },
  { name: "DataSystems", icon: <FaChartBar className="client-logo-svg" /> },
  { name: "SecureNet", icon: <FaCloud className="client-logo-svg" /> },
];

 const clients = [
  { name: "Varna Vision Optical Services", logo: "/assets/logos/varna-vision.png" },
  { name: "House of Vision", logo: "/assets/logos/house-of-vision.png" },
  { name: "Eye Zone", logo: "/assets/logos/eye-zone.png" },
  { name: "Kingdom Opticals", logo: "/assets/logos/kingdom-opticals.png" },
  { name: "Aklo Vision Center", logo: "/assets/logos/aklo-vision.png" },
  { name: "Opex Eye Care Professionals", logo: "/assets/logos/opex-eyecare.png" },
  { name: "Eye World @ Nawaloka Hospital", logo: "/assets/logos/eye-world.png" },
  { name: "Annai Opticals", logo: "/assets/logos/annai-opticals.png" },
  { name: "Vision First", logo: "/assets/logos/vision-first.png" },
  { name: "Lenstech Eye Care Hospital", logo: "/assets/logos/lenstech.png" },
  { name: "Ray Ban Opticians", logo: "/assets/logos/ray-ban-opticians.png" },
  { name: "Pure Vision Seychelles", logo: "/assets/logos/pure-vision.png" },
  { name: "Ekanayake Optical", logo: "/assets/logos/ekanayake-optical.png" },
  { name: "Eric Ganesh Opticals & Dental Services", logo: "/assets/logos/eric g.png" },  { name: "Southern Eye Care", logo: "/assets/logos/southern eye care.png" },
  { name: "Vision Infinity", logo: "/assets/logos/vision infinity.png" },
  { name: "Vision Path Opticals", logo: "/assets/logos/vision path.png" },
  { name: "Ranathunga Opticals", logo: "/assets/logos/ranathunga optical.png" },
  { name: "Eyezen Optical Services", logo: "/assets/logos/eye zen.png" },
  { name: "Eye Contact", logo: "/assets/logos/eye contact.png" },
  { name: "Batticaloa Opticals", logo: "/assets/logos/batticaloa logo.png" },
  { name: "Aloka Water", logo: "/assets/logos/aloka-water.png" },
  { name: "Vinsa Eyecare", logo: "/assets/logos/vinsa-logo.png" },
  { name: "Hero Cleaning Services", logo: "/assets/logos/hero-cleaning.png" },
  { name: "Retionz Cabs & Rent a Car", logo: "/assets/logos/retionz cabs.png" },
];

const marqueeClients = [...clients, ...clients];

const clientsRow1 = clients.slice(0, 12);
const clientsRow2 = clients.slice(12, 23);
const marqueeRow1 = [...clientsRow1, ...clientsRow1];
const marqueeRow2 = [...clientsRow2, ...clientsRow2];

//  const testimonials = [
//   {
//     quote: "GLAXMORE provided us with an exceptional booking system that streamlined our tour operations in Ella and Wellawaya. Their technical expertise is remarkable.",
//     author: "Dineth Prabhashwara",
//     role: "Owner, ChavoTours.lk (Ella-Wellawaya)"
//   },
//   {
//     quote: "Taxi, Tours and wedding hire booking platform created by GLAXMORE has streamlined our entire operation. Their attention to detail and understanding of our needs was exceptional.",    author: "Mr. Dishan Pravishka",
//     role: "Owner, Rydo.lk (Katunayaka)"
//   },
//   {
//     quote: "GLAXMORE implemented an efficient inventory management system for our cleaning business that has saved us countless hours and reduced errors significantly.",
//     author: "Mrs. Keshara",
//     role: "Owner, Hero Cleaning Serice (Moratuwa)"
//   },
//   {
//    quote: "GLAXMORE transformed our eye care operations with a seamless billing, eye exam reporting, and patient follow-up system. It has greatly improved efficiency, accuracy, and patient satisfaction.",
//     author: "Mrs.  Sarojani Ranathunga ",
//     role: "Owner, Ranathunga Opticals (Dambulla)"
//   },
// {
//   quote: "GLAXMORE introduced an advanced billing, eye exam reporting, and patient follow-up system that has streamlined our daily operations. It’s incredibly reliable and has enhanced both efficiency and patient care at our clinic.",
//   author: "Mr. Jayamini Edirisinghe",
//   role: "Owner, Aklo Vision Center (Dehiwala)"
// }

 
// ];







  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    projectTitle: "",
    projectDetails: "",
    budget: "",
    timeline: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "startyourproject"), {
        ...formData,
        createdAt: serverTimestamp(),
      });
      alert("Thank you! We’ll contact you soon.");
      setFormData({
        name: "",
        email: "",
        company: "",
        projectTitle: "",
        projectDetails: "",
        budget: "",
        timeline: "",
      });
      setIsOpen(false);
    } catch (error) {
      console.error("Error saving project:", error);
      alert("Something went wrong, please try again.");
    }
  };





// testamonials of customers
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [isPaused]);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };





  return (
    <div className="home-container">
      {/* ===== HERO SECTION ===== */}
      <section className="hero-section">
        <div className="hero-bg"></div>
        <div className="hero-content-container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="hero-badge">
              <span>Innovating Since 2021</span>
            </div>
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              Transforming Businesses Through
              <span className="gradient-text"> Intelligent Technology</span>
            </motion.h1>
            <motion.p 
              className="hero-subtitle"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.8 }}
            >
              GLAXMORE delivers cutting edge IT solutions that drive growth, efficiency, 
              and competitive advantage for businesses of all sizes.
            </motion.p>
            <motion.div 
              className="hero-cta"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.9, duration: 0.8 }}
            >
              {/* <motion.button 
                className="btn btn-primary"
                whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(37, 99, 235, 0.3)" }}
                whileTap={{ scale: 0.95 }}
              >
                Start Your Project
              </motion.button> */}






  
      {/* Start Project Button */}
  {/* Start Project Button */}
      <motion.button
        className="start-btn"
        whileHover={{
          scale: 1.05,
          boxShadow: "0 10px 25px rgba(37, 99, 235, 0.3)",
        }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(true)}
      >
        Start Your Project
      </motion.button>

      {/* Modal */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="modal-box"
              initial={{ scale: 0.8, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 50 }}
              transition={{ type: "spring", stiffness: 100, damping: 15 }}
            >
              {/* Close Button */}
              <button
                onClick={() => setIsOpen(false)}
                className="modal-close"
              >
                ×
              </button>

              <h2>Tell Us About Project</h2>

              <form onSubmit={handleSubmit} className="form-grid">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="projectTitle"
                  placeholder="Project Title"
                  value={formData.projectTitle}
                  onChange={handleChange}
                  required
                />
                <textarea
                  name="projectDetails"
                  placeholder="Project Details"
                  rows="3"
                  value={formData.projectDetails}
                  onChange={handleChange}
                  required
                ></textarea>
                <input
                  type="text"
                  name="budget"
                  placeholder="Estimated Budget (LKR / USD)"
                  value={formData.budget}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="timeline"
                  placeholder="Expected Timeline"
                  value={formData.timeline}
                  onChange={handleChange}
                />

                <motion.button
                  type="submit"
                  className="submit-btn"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Submit Project
                </motion.button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>











         
            </motion.div>
          </motion.div>
          
        <motion.div 
          className="glax-hero-graphic"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <div className="glax-tech-graphic">
            <div className="glax-floating-element glax-element-1">
           < MdPsychology className="glax-floating-icon" />
            </div>
            <div className="glax-floating-element glax-element-2">
              <FaCloud className="glax-floating-icon" />
            </div>
            <div className="glax-floating-element glax-element-3">
              <FaDatabase className="glax-floating-icon" />
            </div>
            <div className="glax-floating-element glax-element-4">
              <FaCode className="glax-floating-icon" />
            </div>
            <div className="glax-main-circle">
              <div className="glax-inner-circle">
                <FaLaptopCode className="glax-contact-main-icon" />
              </div>
            </div>
          </div>
        </motion.div>
        </div>
        
        <motion.div 
          className="scrolldown-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
        >
          <span>Scroll to explore</span>
          <div className="scroll-line"></div>
        </motion.div>
      </section>

      <motion.section
        className="partner-bar"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.8 }}
        transition={{ duration: 0.8 }}
      >
        <p><b>Powering Businesses with IT Excellence</b></p>

        <div className="partner-badges">
          {partnerBadges.map((partner, index) => (
            <motion.div
              key={index}
              className="partner-badge"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.8 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.1, y: -5 }}
            >
              <div className="partner-badge-icon">{partner.icon}</div>
              <span>{partner.name}</span>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* ===== CLIENT LOGO BAR ===== */}
      <motion.section
        className="client-bar"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.8 }}
        transition={{ duration: 0.8 }}
        aria-label="Trusted by leading enterprises"
      >
        <p className="client-bar-heading">
          Trusted by our valued clients across Sri Lanka
        </p>

        <div className="client-bar-logos">
          <div className="marquee-viewport">
            <div className="marquee-track marquee-track-left">
              {marqueeRow1.map((client, index) => (
                <div
                  className="marquee-logo"
                  key={`row1-${client.name}-${index}`}
                  aria-hidden={index >= clientsRow1.length}
                >
                  <img
                    src={client.logo}
                    alt={index < clientsRow1.length ? client.name : ""}
                    loading="lazy"
                    draggable={false}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="marquee-viewport">
            <div className="marquee-track marquee-track-right">
              {marqueeRow2.map((client, index) => (
                <div
                  className="marquee-logo"
                  key={`row2-${client.name}-${index}`}
                  aria-hidden={index >= clientsRow2.length}
                >
                  <img
                    src={client.logo}
                    alt={index < clientsRow2.length ? client.name : ""}
                    loading="lazy"
                    draggable={false}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.section>

      {/* ===== SERVICES SECTION ===== */}
      <section className="services-section" ref={ref}>
        <div className="section-header">
          <motion.h2
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 }
            }}
            initial="hidden"
            animate={controls}
            transition={{ duration: 0.6 }}
          >
            Our Core Services
          </motion.h2>
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 }
            }}
            initial="hidden"
            animate={controls}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="section-subtitle"
          >
            Comprehensive IT solutions tailored to your business needs
          </motion.p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              variants={{
                hidden: { opacity: 0, y: 50 },
                visible: { opacity: 1, y: 0 }
              }}
              initial="hidden"
              animate={controls}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10, transition: { duration: 0.2 } }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <button className="service-link">
                {/* Learn more <FaArrowRight className="arrow-icon" /> */}
              </button>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ===== STATS SECTION ===== */}
      <section className="stats-section" ref={statsRef}>
        <div className="stats-container">
          <div className="section-header">
            <h2>Our Impact in Numbers</h2>
            <p className="section-subtitle">Delivering measurable results for our clients</p>
          </div>
          <div className="stats-grid">
            <motion.div 
              className="stat"
              initial={{ opacity: 0 }}
              animate={statsInView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6 }}
            >
              <h3><AnimatedNumber from={0} to={32} /></h3>
              <p>Projects Delivered</p>
            </motion.div>
            <motion.div 
              className="stat"
              initial={{ opacity: 0 }}
              animate={statsInView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h3><AnimatedNumber from={0} to={99} />%</h3>
              <p>Client Satisfaction</p>
            </motion.div>
            <motion.div 
              className="stat"
              initial={{ opacity: 0 }}
              animate={statsInView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h3><AnimatedNumber from={0} to={15} /></h3>
              <p>Expert Team Members</p>
            </motion.div>
            <motion.div 
              className="stat"
              initial={{ opacity: 0 }}
              animate={statsInView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h3><AnimatedNumber from={0} to={12} /></h3>
              <p>Industries Served</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS SECTION (fan layout) ===== */}
      <section
        className="testimonials-section testimonials-fan"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="section-header">
          <h2>What Our Clients Say</h2>
          <p className="section-subtitle">Hear from businesses we've transformed</p>
        </div>

        <div className="fan-stage">
          {testimonials.map((testimonial, index) => {
            const total = testimonials.length;
            let offset = index - currentIndex;
            if (offset > total / 2) offset -= total;
            if (offset < -total / 2) offset += total;

            const abs = Math.abs(offset);
            const isCenter = offset === 0;

            return (
              <motion.div
                key={index}
                className={`fan-card ${isCenter ? "fan-card-active" : ""}`}
                style={{ "--accent": testimonial.accent }}
                animate={{
                  x: offset * 220,
                  y: abs * 22,
                  scale: isCenter ? 1.12 : 1 - abs * 0.15,
                  rotate: offset * 7,
                  opacity: abs > 2 ? 0 : 1 - abs * 0.3,
                  filter: `blur(${abs * 2.5}px)`,
                  zIndex: 10 - abs
                }}
                transition={{ type: "spring", stiffness: 120, damping: 18 }}
                onClick={() => handleDotClick(index)}
              >
                <FaQuoteLeft className="fan-card-quote-icon" />
                <p className="fan-card-text">{testimonial.quote}</p>
                <div className="fan-card-author">
                  <h4>{testimonial.author}</h4>
                  <span>{testimonial.role}</span>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="testimonials-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </section>




            {/* ===== FINAL CTA SECTION ===== */}
      <motion.section 
        className="cta-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 1 }}
      >
           <div 
          className="cta-bg-image" 
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/cta-bg.jpg)` }}
        ></div>
        <div className="cta-overlay"></div>

        <div className="cta-glass-panel">
          <div className="cta-content">
            <h2>Ready to Transform Your Business?</h2>
            <p>Let's discuss how GLAXMORE can help you achieve your technology goals and drive growth.</p>
            <div className="cta-buttons">
              <a href="tel:+94701111735">
              <motion.button
                className="btn btn-primary btn-large"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
              >
                Get a Free Consultation
              </motion.button>
            </a>
              <motion.button
                className="btn btn-secondary btn-large"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate("/services")}
              >
                View Our Services
              </motion.button>
            </div>
          </div>
        </div>
      </motion.section>
    </div>
  );
}

export default Body;